import { render, staticRenderFns } from "./wbjzList.vue?vue&type=template&id=8d25451c&"
import script from "./wbjzList.vue?vue&type=script&lang=js&"
export * from "./wbjzList.vue?vue&type=script&lang=js&"
import style0 from "./wbjzList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports